function getDataFromLog(log) {
  const {
    node: {
      frontmatter: { month, app, changeType },
    },
  } = log

  return { month, app, changeType }
}

function getDataFromLogGroup(logGroup) {
  const { edges } = logGroup
  const [log] = edges

  return getDataFromLog(log)
}

function getIsDataVisibleByFilter(filter, logFilter) {
  const hasFilterSelected = filter.length > 0
  const hasFilterLog = filter.includes(logFilter)
  const isVisible = !hasFilterSelected || hasFilterLog

  return isVisible
}

function getIsDataVisibleByAppFilter(filterApps, logApp) {
  return logApp.some(appItem => getIsDataVisibleByFilter(filterApps, appItem))
}

function getIsLogFiltered(log, filterGroup) {
  const { month, app, changeType } = getDataFromLog(log)
  const isVisibleByMonth = getIsDataVisibleByFilter(filterGroup.months, month)
  const isVisibleByApp = getIsDataVisibleByAppFilter(filterGroup.apps, app)
  const isVisibleByChangeType = getIsDataVisibleByFilter(filterGroup.changeTypes, changeType)

  return isVisibleByMonth && isVisibleByApp && isVisibleByChangeType
}

function buildChangelogData(data) {
  const { edges: baseFilter, group: initialData } = data

  const sorttedData = initialData.sort((logGroupA, logGroupB) => {
    const { month: monthA } = getDataFromLogGroup(logGroupA)
    const { month: monthB } = getDataFromLogGroup(logGroupB)

    return monthB.localeCompare(monthA)
  })

  return {
    initialData: sorttedData,
    baseFilter,
  }
}

export { getDataFromLog, getDataFromLogGroup, getIsLogFiltered, buildChangelogData }
